import { routes } from '@/router/routes'

export default {
  namespaced: true,
  state: {
    sidebar: {
      opened: localStorage.getItem('sidebarStatus') == 'true',
      withoutAnimation: false
    },
    device: 'desktop'
  },
  getters: {
    routes: () => routes
  },
  mutations: {
    toggleSideBar: state => {
      localStorage.setItem('sidebarStatus', state.sidebar.opened ? 'false' : 'true')
      state.sidebar.opened = !state.sidebar.opened
      state.sidebar.withoutAnimation = false
    },
    closeSideBar: (state, withoutAnimation) => {
      localStorage.setItem('sidebarStatus', 'false')
      state.sidebar.opened = false
      state.sidebar.withoutAnimation = withoutAnimation
    },
    toggleDevice: (state, device) => {
      state.device = device
    }
  },
  actions: {
    toggleSideBar({ commit }) {
      commit('toggleSideBar')
    },
    closeSideBar({ commit }, { withoutAnimation }) {
      commit('closeSideBar', withoutAnimation)
    },
    toggleDevice({ commit }, device) {
      commit('toggleDevice', device)
    }
  }
}
